import { render, staticRenderFns } from "./ClassSubject.vue?vue&type=template&id=9b1447b4&"
import script from "./ClassSubject.vue?vue&type=script&lang=ts&"
export * from "./ClassSubject.vue?vue&type=script&lang=ts&"
import style0 from "./ClassSubject.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports